"use strict";
// packages/contracts/src/portal-acessos.ts — Fase 17, Plano 05 (PORT-01; D-03, D-04, D-09, D-29).
// Contrato da API INTERNA de gestão de acessos do portal (/api/v1/portal-acessos). SOMENTE tipos. O valor do link
// (token) só existe na resposta que o gera: nenhuma leitura posterior o devolve.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=portal-acessos.js.map